// src/components/Footer.js
import React from 'react';

const Footer = React.forwardRef((props, ref) => {
    return (
        <footer className=" wow fadeIn" data-wow-offset="1" data-wow-duration="1s" data-wow-delay="0.3s">
            <div className="wrap">
                <div className="logo">
                    <img src={props?.data?.logoSmall} alt="Footer Logo" />
                </div>
                <div className="foot_md">
                    <span>電話：{props.data?.footerCall}</span>
                    <span>信箱：{props.data?.footerEmail}</span>
                </div>
                <div className="foot_right">
          <span>
            主辦單位保留活動及課程大綱異動之權利，更新資訊以活動網站內容為主
          </span>
                    <span className="copyright">
            Copyright © 2025 International Trade Administration. All rights reserved
          </span>
                </div>
            </div>
        </footer>
    );
});

export default Footer;
